import { api } from './api';

export interface TreinamentoPorTipo {
  nome: string;
  quantidade: number;
}

export interface DashboardStats {
  totalAlistados: number;

  alistadosAno: number;
  alistadosAnoPassado: number;

  alistadosSemana: number;
  alistadosSemanaPassada: number;

  alistadosDia: number;
  alistadosOntem: number;

  promocoesDia: number;
  promocoesOntem: number;

  treinamentosDia: number;
  treinamentosOntem: number;
  treinamentosPorTipo: TreinamentoPorTipo[];

  patrulhasDia: number;
  patrulhasConcluidasDia: number;
  patrulhasOntem: number;

  acoesDia: number;
  acoesOntem: number;
}

export interface AlistadoMensal {
  mes: string;
  ano: number;
  quantidade: number;
}

export interface DesempenhoGrupo {
  grupoId: string;
  grupoNome: string;
  grupoImg: string;
  acoesSA: number;
  acoesSP: number;
  acoesMes: number;
}

export interface DesempenhoPraca {
  nick: string;
  patente: string;
  patrulhasSA: number;
  patrulhasSP: number;
  patrulhasMes: number;
  treinamentosSA: number;
  treinamentosSP: number;
  treinamentosMes: number;
  auxiliosSA: number;
  auxiliosSP: number;
  auxiliosMes: number;
  grupos: DesempenhoGrupo[];
  diasDesdePromocao: number | null;
  aptoParaPromocao: boolean;
  prazoPatente: number | null;
}

export const dashboardService = {
  getStats: async (): Promise<DashboardStats> => {
    const response = await api.get<DashboardStats>('/dashboard/stats');
    return response.data;
  },

  getAlistadosMensais: async (): Promise<AlistadoMensal[]> => {
    const response = await api.get<AlistadoMensal[]>('/dashboard/alistados-mensais');
    return response.data;
  },

  getDesempenhoPraca: async (nick: string): Promise<DesempenhoPraca> => {
    const response = await api.get<DesempenhoPraca>(`/dashboard/desempenho-praca?nick=${encodeURIComponent(nick)}`);
    return response.data;
  },

  enviarAnalisePromocao: async (nick: string): Promise<void> => {
    await api.post('/dashboard/enviar-analise-promocao', { nick });
  },
};
